import classNames from 'classnames';
import { observer } from 'mobx-react-lite';
import { FC } from 'react';

import { useTranslation } from '@gem/modules/i18n';
import { ICommonPopupsProps, Popup, useClosePopupOnNavigation } from '@gem/popups';
import { customScrollStyles, SwitchMenuItem } from '@gem/ui-kit';

import {
  IChangeSpaceVisibilityPopupPresenterParams,
  useChangeSpaceVisibilityPopupPresenter,
} from './ChangeSpaceVisibilityPopup.presenter';
import styles from './ChangeSpaceVisibilityPopup.styles.m.css';
import { GroupVisibilityItem } from './GroupVisibilityItem/GroupVisibilityItem';

type IChangeSpaceVisibilityPopupProps = IChangeSpaceVisibilityPopupPresenterParams;

export const ChangeSpaceVisibilityPopup: FC<ICommonPopupsProps<IChangeSpaceVisibilityPopupProps>> =
  observer((props) => {
    const { t } = useTranslation();
    const presenter = useChangeSpaceVisibilityPopupPresenter(props);
    useClosePopupOnNavigation(props.popupInstance);

    const containerClassName = classNames(styles.container, customScrollStyles.container);

    return (
      <Popup
        title={t('space_visibility_settings')}
        isOpened={presenter.isOpened}
        handlePrevStep={presenter.hasBackButton ? presenter.onBack : null}
        onClose={presenter.onClose}
      >
        <div className={containerClassName}>
          <SwitchMenuItem
            className={styles.switch}
            title={t('visibility_outspace_show_chats')}
            isChecked={presenter.isAllVisible}
            onChange={presenter.onAllToggle}
          />

          <hr className={styles.separator} />
          <div className={styles.groupList}>
            {presenter.groups.map((group) => (
              <GroupVisibilityItem
                key={group.id}
                group={group}
              />
            ))}
          </div>
        </div>
      </Popup>
    );
  });
